// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AccountSeal } from '@shared/commons/cache/AccountEnums';
import { AssetTradingMode, CalculationMethod } from '../Asset/AssetConst';
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectAccountStatusMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ACCOUNTSTATUS);
        this.AccountId = null;
        this.BstrAccount = null;
        this.Email = null;
        this.TelephoneNumber = null;
        this.FirstName = null;
        this.MiddleName = null;
        this.LastName = null;
        this.UserID = null;
        this.UserLogin = null;
        this.AllowedRoutes = null;
        /// добавили специально для интеграций, храним всякую доп. инфу
        this.AccountDescription = null;
        this.AllowOvernightTrading = null;
        this.CommisionId = null;
        this.CommisionId2 = null;
        this.CommisionId3 = null;
        this.SpreadPlanId = null;
        this.CrossratesPlanId = null;
        this.RiskPlanId = null;
        this.SwapPlanId = null;
        this.ChargingPlanId = null;
        this.FundingRateMarkupPlanId = null;
        this.TodayTrades = null;
        this.FreeCommissionAmount = null;
        // UserId того, кто залочил этого пользователя
        this.LockedBy = null;
        this.AccountMode = AccountSeal.Unspecified;
        // VISIBILITY_FLAG_OWN = 1 - собственный акаунт
        // VISIBILITY_FLAG_GROUP = 2 - видимость по группе
        // VISIBILITY_FLAG_LINK = 4 - видимость по линке
        // VISIBILITY_FLAG_MAM = 5 - видимость по мам группе
        this.AccountVisibilityFlag = 0;
        this.ClientType = 5; // TODO. User.CLIENT_NET
        this.GroupId = -1;
        this.FundType = -1;
        // public MaxOrdersPerDay: any = null
        this.MaxPositions = null;
        this.MaxPendingOrders = null;
        /// #50403
        this.MaxPendingOrdersValue = null;
        this.IsMasterAccount = false;
        this.FollowerIDs = null;
        // +++ AlexB: признак того что юзер подписна сертификатом
        this.IsSigned = false;
        this.IntradayRiskManagement = null;
        this.AllowTradingOnPrepostMarket = null;
        this.TradingLevel = null;
        this.WarningLevel = null;
        this.MarginLevel = null;
        this.TodayVolume = null;
        this.TodayTurnover = null;
        this.MaxDailyLossLimit = null;
        this.MaxDayVolume = null;
        this.MaxOrderCapital = null;
        this.MaxDrawdownLevel = null;
        this.Status = 1;
        this.Role = 0; // TODO. User.ROLE_USER
        this.AccountTradeStatus = null;
        this.StopTradingReason = null;
        // #49740 - для связи аккаунта с интерест планом
        this.InterestsOnBalancePlanID = null;
        this.AssetSharesNames = null;
        this.AccountType = null;
        this.AssetBalances = [];
        this.AssetInfoData = [];
        this.AccountAdditionalInfo = null;
        this.MaxWeeklyLossLimit = null;
        this.TotalMaxPositionsQty = null;
        this.MaxUrealizedLossLimit = null;
        this.AssetAdditionalInfo = null;
        this.ClusterNode = null;
        this.ExtendedFields = {};
        // #97383
        this.DayTraderPattern = null;
        this.DayTraderPatternProtection = null;
        this.AvailableDayTrades = null;
        this.UserAdditionalInfo = null;
        this.StatisticsGroup = null;
        this.PreferredInstrumentType = -1;
        this.BlockedForStocks = null;
        this.pin = null;
        this.login = null;
    }
    get Pin() {
        return this.pin || this.BstrAccount;
    }
    set Pin(value) {
        this.pin = value;
    }
    get Login() {
        return this.login || this.BstrAccount;
    }
    set Login(value) {
        this.login = value;
    }
}
export class AssetInfoDataMessage {
    constructor() {
        // Asset name
        this.Name = '';
        // Total qty
        this.TotalQuantity = 0;
        // Today traded qty (передает один раз при логине, лдальше должны расчитывать сами)
        this.TodayTradedQty = 0;
        // Qty for margin available
        this.TotalQuantityForMarginAvailable = 0;
        // Calculation method (0 - LAST, 1 - PREV_CLOSE)
        this.CalculationMethod = CalculationMethod.Last;
        // Режим торговли (General/Delivery)
        this.AssetTradingMode = AssetTradingMode.Delivery;
    }
}
export class AssetBalanceMessage {
    constructor() {
        this.AssetId = 0;
        this.AvailableMargin = null;
        this.AvailableFunds = null;
        this.Balance = null;
        this.BeginBalance = null;
        this.BlockedForOrders = null;
        this.BlockedForStocks = null;
        // public LockedForPAMM: any = null
        this.BlockedSum = null;
        this.CashBalance = null;
        this.CreditValue = null;
        this.RealizedPnl = null;
        this.MaintanceMargin = null;
        this.MarginDeficiency = null;
        this.MarginSurplus = null;
        this.ReservedBalance = null;
        this.TodayFees = null;
        this.UsedMargin = null;
        this.TodayTurnover = null;
        this.TodayTrades = null;
        this.TodayVolume = null;
        this.TodayRebates = null;
        this.UnsettledProfit = null;
        this.UnsettledLoss = null;
        this.TodaySwaps = null;
        this.CurrentDailyLoss = null;
        this.CurrentWeeklyLoss = null;
        this.TrailingDrawdownLevel = null;
        this.StockOrdersReq = null;
        this.UsedUnsettledNegativePremium = null;
        this.UnusedUnsettledNegativePremium = null;
        this.UnsettledPositivePremium = null;
        this.UnsettledPremiumFromOpenSell = null;
        this.UsedPremiumFromOpenSell = null;
        this.UnusedPremiumFromOpenSell = null;
        this.UsedUnsettledNegativeCashForStocks = null;
        this.UnusedUnsettledNegativeCashForStocks = null;
        this.UnsettledPositiveCashForStocks = null;
        this.StocksLiquidity = null;
        this.IsEmpty = false;
        this.OptionPremiumReq = null;
        this.UnsettledLossAvailableForWithdrawal = null;
        this.WithdrawableCashForStocks = null;
        this.WithdrawableUnsettledPnL = null;
        this.WaivedMargin = null;
        this.WarningMarginRequirement = null;
        this.MarginBeforeWarning = null;
        this.InitialMarginWithoutWaived = null;
        /// <summary>
        /// #82717
        /// </summary>
        this.UnsettledCollateral = null;
        this.WithdrawableUnsettledCollateral = null;
        this.Collateral = null;
        /// #98161
        this.UnusedSettledCashForStocks = null;
        this.UnusedSettledCollateral = null;
        this.UnsettledDeposit = null;
        /// #98625
        this.UnusedIntradayInitialMargin = null;
        this.UsedOvernightInitialMarginForIntraday = null;
        this.AccruedDividends = null;
        this.MaxRelativeDrawDownLevel = null;
        this.LossLimitPerTrade = null;
        this.WithdrawableOptionsPremium = null;
        this.WithdrawalAvailable = null; // #110792
        this.MaintenanceMarginReqPercent = null;
        this.InitialMarginReqPercent = null;
        this.WarningMarginReqPercent = null;
        this.StopOutValue = null; // #119981
        this.EODTrailingDrawdownLevel = null; // #121135
        this.BuyingPowerAvailableFunds = null; // #106952
        // #120451
        this.CalculatedRelativeDailyLossLimit = null;
        this.RelativeOfRelativeDailyLossLimit = null;
        this.CurrentDailyProfit = null;
        this.AvailableCash = null;
        this.TotalPositionsValue = null;
        this.blockedForFixedIncome = null;
        this.fixedIncomeOrdersReq = null;
        this.unusedUnsettledNegativeCashForFixedIncome = null;
        this.usedUnsettledNegativeCashForFixedIncome = null;
        this.unsettledPositiveCashForFixedIncome = null;
        this.withdrawableCashForFixedIncome = null;
        this.unusedUnsettledNegativeAccruedInterest = null;
        this.usedUnsettledNegativeAccruedInterest = null;
        this.unsettledPositiveAccruedInterest = null;
        this.projectedBalance = null;
        this.currentVolumeLimit = null;
        this.relativeVolumeLimit = null;
        this.positionValues = [];
        this.instrumentVolumeLimits = [];
    }
}
